import { Suspense, useEffect } from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher'
import MobileHeader from '@/components/MobileHeader/MobileHeader'
import Footer from '@/components/Footer/Footer'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner'
import { useAnalytics } from '@/hooks/useAnalytics'
import { useLocalePath } from '@/hooks/useLocalePath'
import { HEADER_NAV_ITEMS } from '@/config/navigation'
import '@/App.css'

function App() {
  useAnalytics()
  const { t } = useTranslation()
  const location = useLocation()
  const localePath = useLocalePath()

  const isHome = location.pathname === localePath('/')
  const isActive = (path: string) => location.pathname === localePath(path)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <>
      <MobileHeader />

      {!isHome && (
        <header className="header">
          <div className="headerContent">
            <Link to={localePath('/')} className="logo">
              FAOB<span>.</span>
            </Link>

            <nav className="nav">
              {HEADER_NAV_ITEMS.map((item) => (
                <Link
                  key={item.path}
                  to={localePath(item.path)}
                  className={`navLink ${isActive(item.path) ? 'active' : ''}`}
                >
                  {t(item.labelKey)}
                </Link>
              ))}
            </nav>

            <LanguageSwitcher />
          </div>
        </header>
      )}

      <main className="mainContent">
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </main>

      <Footer />
    </>
  )
}

export default App
